module.exports = function() {
  return new Worker(__webpack_public_path__ + "13763e28bf7ba2b01964.worker.js");
};